module.exports = __webpack_public_path__ + "img/angle-2.8db0da52.svg";